import { cn } from '../lib/utils';

type TLogoProps = {
  text: string;
  className?: string;
  src: string;
};

const Logo = ({ text, className, src }: TLogoProps) => {
  return (
    <img
      src={src}
      alt={text}
      className={cn('h-full w-max object-scale-down', className)}
    />
  );
};

export default Logo;
